let storageWrapper = sessionStorage

export function getStorageWrapper() {
  return storageWrapper
}

export function setStorageWrapper(wrapper) {
  storageWrapper = wrapper
}
